import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { InvoiceHistory, InvoiceSummaryAvisEntryResponse, InvoiceSummaryAvisResponse } from '../../custom-user-payments.models';
import { backToUserPayments, getUserPayments, getUserPaymentsAvis } from '../../store/custom-user-payments-actions';
import { CustomUserPaymentsState } from '../../store/custom-user-payments.reducer';
import { errorUserPaymentsAvis, selectUserPayments, selectUserPaymentsAvis } from '../../store/custom-user-payments.selectors';

@Component({
    selector: 'app-custom-user-payments-avis',
    templateUrl: './custom-user-payments-avis.component.html',
    styleUrls: ['./custom-user-payments-avis.component.scss'],
    standalone: false
})
export class CustomUserPaymentsAvisComponent implements OnInit {

  avisNumber: string;
  avisDate: string;

  invoiceAvis$: Observable<InvoiceSummaryAvisResponse>  =
  this.store.select(selectUserPaymentsAvis);
  errorAvis$: Observable<Error> = this.store.select(errorUserPaymentsAvis);
  invoiceOverview$: Observable<InvoiceHistory>  =
  this.store.select(selectUserPayments);
  invoiceOverview: InvoiceHistory;
  invoiceAvis: InvoiceSummaryAvisResponse;
  entries: InvoiceSummaryAvisEntryResponse[];
  errorAvis: Error;

  constructor(
    private route: ActivatedRoute,
    private routing: RoutingService,
    private store: Store<CustomUserPaymentsState>
  ) { }

  ngOnInit(): void {
    this.avisNumber = this.route.snapshot.paramMap.get('avisNumber');
    this.avisDate =  this.route.snapshot.paramMap.get('avisDate');

    this.invoiceAvis$
    .pipe(
      filter((invoiceAvis) => invoiceAvis != null),
      tap((invoiceAvis) => {
        this.invoiceAvis = invoiceAvis;
        if(invoiceAvis.entries)
        {
          this.entries = [...invoiceAvis.entries];
        }
      })
    )
    .subscribe();

    this.getUserPaymentsAvis();
    this.invoiceOverview$
    .pipe(
      filter((invoiceOverview) => invoiceOverview != null),
      tap((invoiceOverview) => {
        this.invoiceOverview = invoiceOverview;
      })
    )
    .subscribe();
  }

  getUserPaymentsAvis(): void {
    this.store.dispatch(getUserPaymentsAvis({
      avisNumber: this.avisNumber,
      avisDate: this.avisDate,
    }));
  }

  goToUserPayments(): void {
    this.store.dispatch(backToUserPayments());
    if(!this.invoiceOverview)
    {
      this.store.dispatch(getUserPayments());
    }
    this.routing.go({
      cxRoute: 'userPayments',
    });
  }
}
